import NonRotaryAuthorizedInstaller from './NonRAI';

export default NonRotaryAuthorizedInstaller;
